

  // Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import {getFirestore} from 'firebase/firestore'
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAcsl_sHEhtqdSMsqYAV-zeStRZZKNnIGQ",
  authDomain: "tou-aki.firebaseapp.com",
  databaseURL: "https://tou-aki-default-rtdb.firebaseio.com",
  projectId: "tou-aki",
  storageBucket: "tou-aki.appspot.com",
  messagingSenderId: "348086978429",
  appId: "1:348086978429:web:75a2fc91d956ea6b69ee14",
  measurementId: "G-37STGY6PJD"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db=getFirestore(app)



  export {auth, db, analytics};